import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.8071 6.64717L7.28219 1.12225C7.19123 1.03303 7.07604 0.972518 6.95096 0.948237C6.82588 0.923955 6.69642 0.936973 6.57868 0.985675C6.46094 1.03438 6.36011 1.11661 6.28873 1.22216C6.21735 1.3277 6.17856 1.4519 6.1772 1.57931V4.50451H1.62667C1.45503 4.50685 1.29108 4.57607 1.16969 4.69746C1.04831 4.81884 0.979085 4.98279 0.976746 5.15444V9.05504C0.979085 9.22668 1.04831 9.39064 1.16969 9.51202C1.29108 9.63341 1.45503 9.70263 1.62667 9.70497H6.1772V12.6302C6.17667 12.7584 6.21433 12.8839 6.28539 12.9907C6.35646 13.0975 6.4577 13.1807 6.57623 13.2297C6.69475 13.2788 6.82518 13.2914 6.95091 13.266C7.07664 13.2406 7.19197 13.1784 7.28219 13.0872L12.8071 7.5623C12.8682 7.50286 12.9167 7.4318 12.9498 7.3533C12.983 7.2748 13 7.19045 13 7.10524C13 7.02003 12.983 6.93569 12.9498 6.85719C12.9167 6.77868 12.8682 6.70761 12.8071 6.64818V6.64717Z",
		fill: "#545F7E"
	})]
});
const ForwardRef = forwardRef(SvgArrowRightFilled);
export default ForwardRef;
